import React from 'react';
import PropTypes from 'prop-types';
import './calendarWidget.css';
import { connect } from 'react-redux';
import { Popup } from '../../component/popup/';
import { Link } from 'react-router';
import Api from '../../../ui/src/api.js';
import { getCalendarLocations } from '../../actions.js';
import { HeaderIcon } from '../headerIcon';
import { getLocation } from '../../container/calendar/calendar-events';
import Cookies from 'js-cookie';
import moment from 'moment';
import { getProp } from '../../../ui/src/utilities';

class CalendarWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
      currentCalendarLocation: null,
      overview: [],
    };
    this.cookiekey = 'calendarlocation';
    this.getPopupLocations = this.getPopupLocations.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getCalendarLocations()).then(() => {
      // get current location from cookies
      let locationSet = false;
      let calendarLocation = Cookies.get(this.cookiekey);
      if (calendarLocation) {
        for (let location of getProp(this.props, 'calendarLocations', [])) {
          if (location._id === calendarLocation) {
            this.setNewLocation(calendarLocation);
            locationSet = true;
            break;
          }
        }
      }

      // no location stored, set the default one
      if (!locationSet && this.props.calendarLocations && this.props.calendarLocations.length) {
        this.setNewLocation(this.props.calendarLocations[0]._id);
      }
    });
  }

  setNewLocation(locationId) {
    let newLoc = null;
    newLoc = getLocation(locationId, this.props.calendarLocations);

    if (newLoc) {
      Cookies.set(this.cookiekey, locationId);
      this.setState({
        currentCalendarLocation: newLoc,
        overview: [],
      });
      Api.get(`/calendar/${newLoc._id}`).then(response => {
        this.setState({
          currentCalendarLocation: newLoc,
          overview: response.overview,
        });
      });
    }
  }

  onClickPopupItem(item) {
    this.setNewLocation(item._id);
    this.setState({ popupOpened: false });
  }

  getPopupLocations() {
    const locations = getProp(this.props, 'calendarLocations', []).map(item => (
      <a
        key={item._id}
        onClick={(e) => {e.preventDefault(); this.onClickPopupItem(item)}}
        href=""
      >
        {item.name}
      </a>
    ));
    const allLocations = {
      _id: 'all',
      name: 'Východ',
      order: 1,
    };
    locations.unshift(
      <a
        onClick={(e) => { e.preventDefault();this.onClickPopupItem(allLocations) }}
        href=""
      >
        {allLocations.name}
      </a>,
    );
    return locations ? locations : [];
  }

  render() {
    return (
      <div className="calendar-widget">
        <div className="h1 font-medium" style={{ fontWeight: '400' }}>
          Kalendár{' '}
          <span className="text-primary font-light">
            {getProp(this.state, 'currentCalendarLocation.name', '')}
          </span>&nbsp;
          <Link
            className="btn btn-primary btn-xs text-uppercase"
            to={`/calendar/${getProp(
              this.state,
              'currentCalendarLocation._id',
            )}`}
          >
            zobraziť
          </Link>&nbsp;
          <span style={{ position: 'relative', display: 'inline-block' }}>
            <button
              className="btn btn-primary btn-xs text-uppercase popup-trigger"
              onClick={() =>
                this.setState({ popupOpened: !this.state.popupOpened })
              }
            >
              zmeniť
            </button>
            <span className="popup-container">
              <Popup
                opened={this.state.popupOpened}
                items={this.getPopupLocations()}
                handleClickOutside={() => this.setState({ popupOpened: false })}
                outsideClickIgnoreClass={'popup-trigger'}
                eventTypes="click"
              />
            </span>
          </span>
        </div>
        <div className="row">
          {this.state.overview.length > 0 ? (
            this.state.overview.map((item, idx) => {
              return (
                <div key={idx} className="col-sm-4">
                  <CalendarDay
                    date={item.date}
                    events={item.events || []}
                    locationId={this.state.currentCalendarLocation._id}
                  />
                </div>
              );
            })
          ) : (
              // vyplnime priestor...
              <div className="col-sm-8" />
            )}
          {this.state.currentCalendarLocation && (
            <div className="col-sm-4">
              <div>
                <Link
                  to={`/calendar/add/${this.state.currentCalendarLocation._id}`}
                >
                  <HeaderIcon
                    icon="calendar-add"
                    title="Pridať"
                    subtitle="Akciu, udalosť…"
                  />
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CalendarWidget.propTypes = {
  dispatch: PropTypes.func.isRequired,
  calendarLocations: PropTypes.array.isRequired,
};

const mapStateToProps = state => {
  return {
    calendarLocations: state.calendar.locations,
  };
};

export default connect(mapStateToProps)(CalendarWidget);

const CalendarDay = props => {
  const date = moment(props.date).startOf('day');
  let dateStr = date.format('dddd, D.M.YYYY');
  dateStr = `${dateStr[0].toLocaleUpperCase()}${dateStr.substr(1)}`;
  let diff = date.diff(moment().startOf('day'), 'day');
  let dateWord = dateStr;
  let icon = 'calendar';
  if (diff === 0) {
    dateWord = 'Dnes';
    icon = 'calendar-today';
  } else if (diff === 1) {
    dateWord = 'Zajtra';
    icon = 'calendar-tomorrow';
  } else {
    let day = date.format('dddd');
    dateWord = `${day[0].toLocaleUpperCase()}${day.substr(1)}`;
  }

  let events = [];
  for (const e of props.events) {
    const event_from = moment(e.dates[0]['from']);
    events.push(
      <div style={{ minHeight: '60px' }}>
        <div className="h5">
          <Link
            to={`/calendar/${e.location}/${moment(event_from)
              .startOf('day')
              .format('YYYY-MM-DD')}`}
          >
            <span className="text-primary">
              {event_from.format('HH:mm')} -{' '}
            </span>
            {e.title}
          </Link>
        </div>
        <p className="desc">
          {e.description
            ? e.description.length > props.maxDescriptionLength
              ? e.description.substr(0, props.maxDescriptionLength) + '...'
              : e.description
            : ''}
        </p>
      </div>,
    );
  }

  const datef = date.format('YYYY-MM-DD');

  return (
    <div>
      <Link to={`/calendar/${props.locationId}/${datef}`}>
        <HeaderIcon icon={icon} title={dateWord} subtitle={dateStr} />
      </Link>
      <div>
        {events.length ? (
          <RotateWidget items={events} />
        ) : (
            <p className="desc">
              <Link to={`/calendar/add/${props.locationId}?date=${datef}`}>
                Pridať akciu, udalosť...
            </Link>
            </p>
          )}
      </div>
    </div>
  );
};

CalendarDay.propTypes = {
  date: PropTypes.string.isRequired,
  events: PropTypes.array,
  locationId: PropTypes.string.isRequired,
  maxDescriptionLength: PropTypes.number,
};
CalendarDay.defaultProps = {
  events: [],
  maxDescriptionLength: 60,
};

class RotateWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentItem: 0,
    };
    this.timer = null;

    this.rotate = this.rotate.bind(this);
    this.pauseRotation = this.pauseRotation.bind(this);
  }

  rotate() {
    this.timer = window.setTimeout(() => {
      if (this.props.items.length > this.state.currentItem + 1) {
        this.setState({
          currentItem: this.state.currentItem + 1,
        });
      } else {
        this.setState({
          currentItem: 0,
        });
      }
      this.rotate();
    }, this.props.interval);
  }

  componentDidMount() {
    this.rotate();
  }

  componentWillUnmount() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  pauseRotation() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  render() {
    return (
      <div onMouseEnter={this.pauseRotation} onMouseLeave={this.rotate}>
        {this.props.items[this.state.currentItem]}
      </div>
    );
  }
}

RotateWidget.defaultProps = {
  items: [],
  interval: 3400,
};

RotateWidget.propTypes = {
  items: PropTypes.array,
  interval: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/app/component/calendarWidget/calendarWidget.js